if (!customElements.get('terms-checkbox')) {
  class TermsCheckbox extends HTMLElement {
    constructor() {
      super();
      this.observer = null;
    }

    connectedCallback() {
      this.append = this.dataset.append || '';
      // Cerca la checkbox dentro questo custom element
      this.terms_checkbox = this.querySelector(`#CartTerms${this.append}`) || this.querySelector('input[type="checkbox"]');
      const error_string = this.closest('form')?.querySelector('[data-error]')?.dataset.error || 'Devi accettare i termini e le condizioni';
      // Imposta messaggio errore
      if (this.terms_checkbox) {
        const errorMessage = (typeof theme !== 'undefined' && theme.strings && theme.strings.requiresTerms) 
                             ? theme.strings.requiresTerms 
                             : error_string;
        this.terms_checkbox.setCustomValidity(errorMessage);
      }

      // Tenta di agganciare il bottone subito
      if (!this.findAndBindButton()) {
        // Se il bottone non c'è ancora, osserva il parentNode
        this.observeParent();
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    observeParent() {
      // Se non abbiamo un parentNode, non possiamo fare nulla
      if (!this.parentNode) return;

      this.observer = new MutationObserver((mutations) => {
        // Ogni volta che cambia qualcosa nel parentNode, riproviamo a cercare il bottone
        if (this.findAndBindButton()) {
          // Se lo troviamo, smettiamo di osservare per risparmiare risorse
          this.observer.disconnect();
          this.observer = null;
        }
      });

      // Osserva aggiunte di figli nel parentNode
      this.observer.observe(this.parentNode, { childList: true, subtree: true });
    }

    findAndBindButton() {
      if (!this.parentNode) return false;

      // DEFINIAMO I SELETTORI:
      // 1. .checkout-button (per il carrello standard)
      // 2. .xo-btn (per il form create_customer)
      // 3. button[type="submit"] (fallback generico se necessario)
      const buttonSelector = '.checkout-button, .xo-btn, #create_customer button[type="submit"]';

      // USARE SOLO parentNode come richiesto
      const btn = this.parentNode.querySelector(buttonSelector);

      if (btn) {
        // Evita di aggiungere l'evento più volte allo stesso bottone
        if (btn.dataset.termsBound) return true;

        console.log('Button found inside parentNode:', btn);
        
        btn.addEventListener('click', (e) => {
          if (this.terms_checkbox && !this.terms_checkbox.checked) {
            e.preventDefault();
            e.stopImmediatePropagation(); // Blocca altri script
            this.terms_checkbox.reportValidity();
            this.terms_checkbox.focus();
          }
        });

        // Marca il bottone come "collegato"
        btn.dataset.termsBound = "true";
        return true;
      }
      
      return false;
    }
  }
  
  customElements.define('terms-checkbox', TermsCheckbox);
}